import { ThemeProvider } from "@emotion/react";
import "./App.css";
import UserContextProvider from "./contexts/UserContext";
import { SecurityHandler } from "./services/SecurityHandler";
import CustomRouter from "./Router";
import { MUI_THEME } from "./style/MuiTheme";
import moment from "moment";
import GlobalContextProvider from "./contexts/GlobalContext";

function App() {
  const theme = MUI_THEME;
  moment.locale("fr");

  return (
    <UserContextProvider>
      <SecurityHandler></SecurityHandler>
      <GlobalContextProvider>
        <ThemeProvider theme={theme}>
          <CustomRouter />
        </ThemeProvider>
      </GlobalContextProvider>
    </UserContextProvider>
  );
}

export default App;
